import './NewMessageList.scss'
import { useGetNewMessages } from '../api/get-new-messages';
import { useAuth } from '../../../../contexts/auth';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { formatShortDate, formatShortTime } from '../../../../utils/date-utils';
import { NewMessageListProps } from '../types/NewMessageListProps';

export default function NewMessageList(props: NewMessageListProps) {

	const { user } = useAuth();
	const messages = useGetNewMessages(user?.userName!);
	const todayStr = new Date().toDateString();

	return (<div className='message-list-container'>
		{
			messages.isLoading &&
			<LoadIndicator width={'24px'} height={'24px'} visible={true} />
		}
		{
			!messages.isLoading && messages.data.length > 0 ?
				<ul className='message-list'>
					{
						messages.data.map((message) => {
							return <li key={message.notificationQueueID}
								onClick={() => props.onMessageClicked(message)}
								className={message.isRead ? 'read-message' : 'unread-message'}
							>
								{
									!message.isRead &&
									<div className='unread-message-indicator'></div>
								}
								<div className='new-message-received-on'>
									{message.createdOn.toDateString() === todayStr ?
										formatShortTime(message.createdOn) : formatShortDate(message.createdOn)
									}
								</div>
								<div className='new-message-from'>
									{message.from}
								</div>
								<div className='new-message-order-number'>
									<span className='new-message-order-number-label'>Order #:</span>
									{message.orderNumber}
								</div>
								<div className='new-message-text'>
									{message.messageText}
								</div>
							</li>
						})
					}
				</ul>
				:
				<div className='no-new-messages'>
					No new messages
				</div>
		}
	</div>)
}